import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./index.css";
import Home from "./components/Home";
import Proposal from "./components/Proposal";
import Proposals from "./components/Proposals";
import Jobs from "./components/Jobs";
import NewProposal from "./components/NewProposal";
import nftAbi from "./Populus/PopulusNFT.json";
import { ethers } from "ethers";
import axios from "axios";
import home from "./img/home.png";
import jobs from "./img/portfolio.png";
import scale from "./img/scale.png";
import placeholder from "./img/placeholder.jpeg";

function App() {
  const [haveMetamask, sethaveMetamask] = useState(true);
  const [accountAddress, setAccountAddress] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [nftData, setNftData] = useState();
  const [governanceValue, setGovernanceValue] = useState();

  const { ethereum } = window;
  // const provider = new ethers.providers.Web3Provider(window.ethereum);

  useEffect(() => {
    const { ethereum } = window;
    const checkMetamaskAvailability = async () => {
      if (!ethereum) {
        sethaveMetamask(false);
      }
      sethaveMetamask(true);
    };
    checkMetamaskAvailability();
  }, []);

  const connectWallet = async () => {
    try {
      if (!ethereum) {
        sethaveMetamask(false);
      }
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      setAccountAddress(accounts[0]);
      setIsConnected(true);
      var provider1 = new ethers.providers.AlchemyProvider(
        "matic",
        "_8TZHcd_cqmy0KNW3bQuBEDWhnnRIzg5"
      );
      const getUserData = async () => {
        const contract = new ethers.Contract(
          "0x471B4Ad30ac2FF7207dDC8d223239B740BC06376",
          nftAbi,
          provider1
        );
        console.log("userAddress", accounts[0]);
        await window.ethereum.enable();
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        console.log("hjoe", await contract.connect(signer));
        const tokenID = await contract.connect(signer).viewTokenID(accounts[0]);
        const govValue = await contract
          .connect(signer)
          .governanceValue(accounts[0]);
        console.log("tokenID, govValue", tokenID, govValue);
        setGovernanceValue(govValue);
        const tokenUri = await contract.connect(signer).tokenURI(tokenID);
        axios
          .get(tokenUri)
          .then(function (response) {
            console.log(response);
            setNftData(response.data);
          })
          .catch(function (error) {
            console.log(error);
          });
      };
      getUserData();
    } catch (error) {
      setIsConnected(false);
    }
  };

  const disconnectWallet = async () => {
    setIsConnected(false);
  };
  return (
    <BrowserRouter>
      <div className="rowDynamic">
        <div className="sideMenu">
          <a
            href="https://chicagodao.io"
            className="sideMenuBox borderBottom"
            target="_blank"
            rel="noreferrer"
          >
            <img src={home} className="sideMenuIcon" alt="side Menu Icon" />
          </a>
          <Link to="/" className="sideMenuBox borderBottom">
            <img src={scale} className="sideMenuIcon" alt="side Menu Icon" />
          </Link>
          <Link to="/jobs" className="sideMenuBox borderBottom">
            <img src={jobs} className="sideMenuIcon" alt="side Menu Icon" />
          </Link>
        </div>
        <Routes>

          <Route
            path="/"
            element={
              <Home
                accountAddress={accountAddress}
                nftData={nftData}
                governanceValue={governanceValue}
              />
            }
          >

            <Route
              index
              element={<Proposals accountAddress={accountAddress} />}
            />
            <Route
              path="/proposal/new"
              element={<NewProposal accountAddress={accountAddress} />}
            />
            <Route
              path="proposal/:proposalId"
              element={<Proposal accountAddress={accountAddress} />}
            />
          </Route>
          <Route
              path="/jobs"
              element={<Jobs accountAddress={accountAddress} />}
            />
        </Routes>
        <div className="rightMenu widgetStyling">
          <h1 className="titleMain marginBottom darkMaroonText">Profile </h1>
          <div className="walletDiv">
            {haveMetamask ? (
              <>
                {isConnected ? (
                  <button
                    className="walletConnected"
                    onClick={disconnectWallet}
                  >
                    <span className="walletButtonText">
                      {accountAddress.slice(0, 4)}...
                      {accountAddress.slice(38, 42)}
                    </span>
                  </button>
                ) : (
                  <button className="walletButton" onClick={connectWallet}>
                    <span className="walletButtonText">CONNECT</span>
                  </button>
                )}
              </>
            ) : (
              <p>Please Install MetaMask</p>
            )}
          </div>
          <div className="profileMain">
            <div className="profileImageDiv">
              <img
                className="profileImage"
                alt="profile"
                src={governanceValue ? nftData?.image : placeholder}
              />
            </div>
            <h1 className="titleCenterSmaller marginBottom darkMaroonText">
              {governanceValue ? nftData?.attributes?.[2]?.value : "-----"}
            </h1>
            <br/>
            <div className="row width100 justifyBetween">
              <div className="profileSubBox">
                <h1 className="subtitleThin darkMaroonText">
                  <h1 className="titleCenterSmaller">
                    {governanceValue ? governanceValue : "--"}
                  </h1>
                  Governance
                </h1>
              </div>
              <div className="profileSubBox">
                <h1 className="subtitleThin darkMaroonText">
                  <h1 className="titleCenterSmall">
                    {governanceValue ? nftData?.attributes?.[4]?.value : "--"}
                  </h1>
                  School
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
